<template>
  <div>
    <div v-show="exibirListaPedido" v-if="mostraPedidos">
      <new-items-vue :title=titlePageLista placeholderNm="IDGosales, Razão, Fant., Ped., Orç., Ped. Compra ..."></new-items-vue>
      <table-pedidos-vue></table-pedidos-vue>
    </div>
    <div v-show="exibirSelecionarCliente" v-if="mostraPedidos">
      <new-items-clientes-vue title="SELECIONAR CLIENTE"  placeholderNm="Cód. Cliente, Fantasia, Razão, CNPJ e Endereço" placeholderCid="Cidade"></new-items-clientes-vue>
      <table-acoes-vue title="Lista de clientes"></table-acoes-vue>
    </div>
    <div v-show="novoPedido" v-if="mostraPedidos">
      <novo-pedido-vue title="NOVO PEDIDO" :clienteSelecionado="cliente"></novo-pedido-vue>
    </div>
    <p id="construcao" v-if="!mostraPedidos">Desculpe o transtorno, estamos trabalhando para melhor atendê-los!</p>
  </div>
</template>
<script>
  import NewItemsVue from '@/components/items/NewItemsVue'
  import App from '@/App'
  import TablePedidosVue from '@/components/items/TablePedidosVue'
  import tableAcoesVue from '@/components/items/TableAcoesVue'
  import { broadcastServer } from '@/main'
  import NewItemsClientesVue from '@/components/items/NewItemsClientesVue'
  import NovoPedidoVue from '@/components/items/NovoPedidoVue'

  export default {
    name: 'Pedidos',
    components: {
      NewItemsClientesVue,
      App,
      NewItemsVue,
      TablePedidosVue,
      tableAcoesVue,
      NovoPedidoVue
    },
    data () {
      return {
        exibirListaPedido: true,
        exibirSelecionarCliente: false,
        novoPedido: false,
        cliente: {},
        mostraPedidos: true
      }
    },
    created () {
      window.addEventListener('beforeunload', this.toTopOnRefresh)
      let empresa = localStorage.getItem('empresaLogada')
      if (JSON.parse(empresa).identificador === 2355480534) {
        this.titlePageLista = 'ORÇAMENTOS'
        this.mostraPedidos = false
      } else {
        this.titlePageLista = 'PEDIDOS'
      }
      broadcastServer.$on('adicionarPedido', param => {
        this.exibirListaPedido = false
        this.exibirSelecionarCliente = true
        this.novoPedido = false
      })
      broadcastServer.$on('exibirLista', param => {
        window.scrollTo(0, 0)
        this.exibirListaPedido = true
        this.exibirSelecionarCliente = false
        this.novoPedido = false
      })
      broadcastServer.$on('clienteSelecionado', cliente => {
        window.scrollTo(0, 0)
        this.exibirListaPedido = false
        this.exibirSelecionarCliente = false
        this.novoPedido = true
        this.cliente = cliente
      })
      broadcastServer.$on('vizualizarPedido', param => {
        window.scrollTo(0, 0)
        this.exibirListaPedido = false
        this.exibirSelecionarCliente = false
        this.novoPedido = true
      })
    },
    methods: {
      toTopOnRefresh: function toTopOnRefresh (event) {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
<style scoped>
.btnAdicionar{
  display: none;
}
#construcao {
  font-size: 22px;
  margin-top: 150px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PedidosVue.vue